import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, InputNumber } from "antd";
import { DepenseService } from "../../services/DepenseService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./DepenseCreateForm.module.scss";

const DepenseCreateForm = ({ visible, onCreate, onCancel, affaire }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [creating, setCreating] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  const handleSave = (isRedirection) => {
    setCreating(true);
    form
      .validateFields()
      .then((values) => {
        values.affaire_id = affaire.id;
        DepenseService.getInstance()
          .create(values)
          .then((response) => {
            Toast.success(response.message);
            form.resetFields();
            onCreate(response.data);
            if (isRedirection) {
              navigate(`/depense/${response.data.uid}`);
            }
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setCreating(false);
          });
      })
      .catch(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title="Créer un nouveau depense"
      footer={[
        <>
          <Row gutter={24}>
            <Col>
              <Button
                key="cancel"
                onClick={onCancel}
                className={style.ButtonNew}
              >
                Annuler
              </Button>
            </Col>
            <Col>
              <Button
                key="save-show"
                type="primary"
                loading={creating}
                onClick={() => handleSave(true)}
                className={style.ButtonNew}
              >
                Enregistrer et Afficher
              </Button>
            </Col>
            <Col>
              <Button
                key="save-again"
                type="primary"
                loading={creating}
                onClick={() => handleSave(false)}
                className={style.ButtonNew}
              >
                Enregistrer et Créer
              </Button>
            </Col>
          </Row>
        </>
      ]}
    >
      <Card style={{ marginBottom: 5 }}>
        <Form
          layout="vertical"
          form={form}
          name="createDepenseForm"
          initialValues={{
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Désignation"
                name="designation"
                rules={[{ required: true, message: "Veuillez saisir la designation!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Montant"
                name="montant"
                rules={[{ required: true, message: "Veuillez saisir le montant!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <InputNumber min={0} className="w-100" suffix={affaire.monnaie.symbole} />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Date"
                name="date"
                rules={[
                  { required: true, message: "Veuillez saisir la date!" },
                  {
                    validator: (_, value) => {
                      if (value && new Date(value) > new Date()) {
                        return Promise.reject("La date doit être inférieure ou égale à la date d'aujourd'hui");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="date" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem help="Veuillez saisir un commentaire pour décrire la depense"
                label="Commentaire (optionnel)"
                name="commentaire"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input.TextArea rows={4} />
              </CustomFormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default DepenseCreateForm;

DepenseCreateForm.propTypes = {
  visible: PropTypes.bool,
  onCreate: PropTypes.func,
  onCancel: PropTypes.func,
  affaire: PropTypes.object.isRequired,
};
